import { render, staticRenderFns } from "./adddashed.vue?vue&type=template&id=f0b3c67c&scoped=true&"
import script from "./adddashed.vue?vue&type=script&lang=js&"
export * from "./adddashed.vue?vue&type=script&lang=js&"
import style0 from "./adddashed.vue?vue&type=style&index=0&id=f0b3c67c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b3c67c",
  null
  
)

export default component.exports